import { Component, OnInit } from '@angular/core';
import { MatDialogRef} from '@angular/material/dialog';
import { GlobalService } from 'app/services/global.service';
import Utils from '../utility';

@Component({
  selector: 'app-reset-hc-quest-data-msg',
  templateUrl: './reset-hc-quest-data-msg.component.html',
  styleUrls: ['./reset-hc-quest-data-msg.component.css']
})
export class ResetHcQuestDataMsgComponent implements OnInit {
  public client: any;
  

  constructor(private dialogRef: MatDialogRef<ResetHcQuestDataMsgComponent>, public globalService: GlobalService) { }

  ngOnInit() {
    this.getClient();
  }

  resetData() {
    this.dialogRef.close('reset');
    // this.updateClientProfileWithResetHCQuestionnaire();

  }
  getClient() {

    this.globalService.getClientData(Number(localStorage.getItem("selectedClient")), 4)
        .subscribe(
            client => {
                this.client = client;
                console.log('this.client',this.client)
               
            },
            error => console.log(error));
  }

  updateClientProfileWithResetHCQuestionnaire() {
    var ClientProfile = {
      ClientID: this.client.clientProfile.ClientID,
      MaritalStatus: this.client.clientProfile.MaritalStatus,
      CurrentIncome: this.client.clientProfile.CurrentIncome,
      IRR: this.client.clientProfile.IRR ,
      RetirementAge: this.client.clientProfile.RetirementAge,
      Pension: this.client.clientProfile.Pension,
      RetirementState: this.client.clientProfile.RetirementState,
      SpouseID: this.client.clientProfile.SpouseID,
      LifeExpectancy: this.client.clientProfile.LifeExpectancy,
      HCHBP: this.client.clientProfile.HCHBP ? 1 : 0,
      HCHC: this.client.clientProfile.HCHC ? 1 : 0,
      HCT2D: this.client.clientProfile.HCT2D ? 1 : 0,
      HCCD: this.client.clientProfile.HCCD ? 1 : 0,
      HCC: this.client.clientProfile.HCC ? 1 : 0,
      HCT: this.client.clientProfile.HCT ? 1 : 0,

      HCALZ: this.client.clientProfile.HCALZ ? 1 : 0,
      HCPARK: this.client.clientProfile.HCPARK ? 1 : 0,
      HCAMP: this.client.clientProfile.HCAMP ? 1 : 0,
      HCPTSD: this.client.clientProfile.HCPTSD ? 1 : 0,
      HCOBS: this.client.clientProfile.HCOBS ? 1 : 0,

      Spouses: JSON.stringify(this.client.clientProfile.Spouses),
      Children: this.client.clientProfile.Children && this.client.clientProfile.Children.length > 0 ? this.client.clientProfile.Children : null,//JSON.stringify(this.client.clientProfile.Children),
      PensionMonths: this.client.clientProfile.PensionMonths,
      PensionYears: this.client.clientProfile.PensionYears,
      SubstantialEarningYears: this.client.clientProfile.SubstantialEarningYears,
      IncludePension: this.client.clientProfile.IncludePension,
      PIA: this.client.clientProfile.PIA,
      PIAYears: (!this.client.clientProfile.PIAYears || this.client.clientProfile.PIAYears == 'null') ? null : JSON.stringify(this.client.clientProfile.PIAYears),
      UseNationalAverage: this.client.clientProfile.UseNationalAverage,
      IsRunReportWithSpouse: this.client.clientProfile.IsRunReportWithSpouse,
      IsLegalSpouse: this.client.clientProfile.IsLegalSpouse,
      HCT1D: this.client.clientProfile.HCT1D ? 1 : 0,
      HCMS: this.client.clientProfile.HCMS ? 1 : 0,
      HCDCW: this.client.clientProfile.HCDCW ? 1 : 0,
      HCFHDC: this.client.clientProfile.HCFHDC ? 1 : 0,
      IsPrivHealthIns: null,
      CoverageType: null,
      PremiumType: null,
      Premiums:  null,
      IsHSApplySpouse: null,
      IsSpousePrivHealthIns: null,
      SpouseCoverageType: null,
      SpousePremiumType: null,
      SpousePremiums: null,
      Bracket: null,
      InflationRate: null,
      HouseholdYearOneIncome: null,
      HouseholdYearOneIncomeChangeYear: null,
      InRetirementInflationRate: null,
      MAGIPercentIncome: null,
      OOPCosts: null,
      SpouseOOPCosts: null,
      ClientMetroArea: null,
      SpouseMetroArea: null
     }

    var UserModel = {
      ID: this.client.client ? this.client.client.ID : 0,
      FirstName: this.client.client.FirstName,
      LastName: this.client.client.LastName,
      AdvisorID: this.client.client.AdvisorID,
      OrganizationID: this.client.client.OrganizationID,
      Username: this.client.client.Username,
      GenderID: this.client.client.GenderID,
      DOB: this.client.client.DOB,
      Email: this.client.client.Email,
      Phone: this.client.client.Phone,
      Address: this.client.client.Address,
      City: this.client.client.City,
      State: this.client.client.State,
      Zip: this.client.client.Zip,
    }
    var RiskTolerance = null;
    var AdditionalQuestion = null;
    if (this.client.additionalQuestion.Firm || this.client.additionalQuestion.PlanSponsor || this.client.additionalQuestion.Wholesaler || this.client.additionalQuestion.SendReportTo || this.client.additionalQuestion.RepName || this.client.additionalQuestion.MeetingReference) {
      AdditionalQuestion = {
        Firm: this.client.additionalQuestion.Firm,
        PlanSponsor: this.client.additionalQuestion.PlanSponsor,
        Wholesaler: this.client.additionalQuestion.Wholesaler,
        SendReportTo: this.client.additionalQuestion.SendReportTo,
        RepName: this.client.additionalQuestion.RepName,
        MeetingReference: this.client.additionalQuestion.MeetingReference,
        FromHCLTCComb: 'HC',
        IsDeleted: true
      }
    }

    var MidRetirementAdj = null;
    if (this.client.midRetirementAdj.Year || this.client.midRetirementAdj.ReductionDollar || this.client.midRetirementAdj.ReductionPerc || this.client.midRetirementAdj.IncomeInflationRate) {
      MidRetirementAdj = {
        Year: this.client.midRetirementAdj.Year,
        ReductionDollar: this.client.midRetirementAdj.ReductionDollar,
        ReductionPerc: this.client.midRetirementAdj.ReductionPerc,
        IncomeInflationRate:  this.client.midRetirementAdj.IncomeInflationRate,
        IsDeleted: true
      }
    }


    var modalData;
    let LstMAGIProj = JSON.parse(this.client.magiProjs);
    let newMAGIProj = [];
    if (LstMAGIProj) {
      for(var data of LstMAGIProj) {
        modalData = {
          Year: Number(data.Year),
          Age: data.age,
          Income: data.Income ? Number(Utils.removeCurrencyFormatting(data.Income.toString())) : null,
          MAGI: data.MAGI ? Number(Utils.removeCurrencyFormatting(data.MAGI.toString())): null,
          Bracket: data.Bracket ? Number(data.Bracket): null,
          IsDeleted: true
        }
        newMAGIProj.push(modalData);
      }
    }

    console.log('UserModel', UserModel)
    console.log('ClientProfile', ClientProfile);
    console.log('AdditionalQuestion', AdditionalQuestion);
    console.log('MidRetirementAdj', MidRetirementAdj);
    console.log('LstMAGIProj', LstMAGIProj);
   
    this.globalService.createClient(UserModel, ClientProfile , RiskTolerance, AdditionalQuestion, MidRetirementAdj, newMAGIProj)
    .subscribe(
      resp => {

      },
      error => {

      });
  }
  close() {
    this.dialogRef.close();
  }

}
